import { useCallback } from 'react';
import { selectUser } from '../../common/store/slices/auth.slice';
import { useResize } from '../../common/hooks/resize';
import { useAppSelector } from '../../common/hooks/redux';
import { useModuleProjectContext } from 'common/contexts/useModuleProjectContext';
import Intercom from '@intercom/messenger-js-sdk';
import { intercomMessengerConfig } from 'common/utils/trackingIdentity';

export const useIntercom = () => {
  const user = useAppSelector(selectUser);
  const { activeProject } = useModuleProjectContext();
  const { isMobile } = useResize();

  const initiateIntercom = useCallback(() => {
    if (user?.email && user.externalName && user.companyName && !isMobile && user.id) {
      // #194/#23: the API supplies the id and its signed JWT; nothing is signed here.
      Intercom(intercomMessengerConfig(user, activeProject, Date.now()));
    }
  }, [user, isMobile, activeProject]);

  return { initiateIntercom };
};
